import { Paper } from '@mui/material'
import { REWARDS_TABS } from '../../../components/navigation'
import { NavTabs, useNavTabs } from '../../../components/navigation/NavTabs'
import { useStoreState } from '../../../store/hooks'
import { RewardsAchievements } from './RewardsAchievements'
import { RewardsChallenges } from './RewardsChallenges'

const REWARDS_CONTENT = {
    [REWARDS_TABS.CHALLENGES]: <RewardsChallenges />,
    [REWARDS_TABS.ACHIEVEMENTS]: <RewardsAchievements />,
}

export const Rewards = () => {
    const isCompletedChallenges = useStoreState((state) => state.rewardsService.isCompletedChallenges)
    const { currentTab } = useNavTabs(REWARDS_TABS)

    // const achievements = useStoreState((state) => state.rewardsService.achievements)
    const badges = {
        [REWARDS_TABS.CHALLENGES]: isCompletedChallenges,
    }

    return (
        <>
            <NavTabs tabs={REWARDS_TABS} badges={badges} />
            <Paper
                sx={{
                    display: 'flex',
                    padding: 0,
                    '> div': {
                        padding: 1.5,
                    },
                    flexGrow: 1,
                    overflowY: 'auto',
                    height: { xs: 'calc(100vh - 364px)', md: 'unset' },
                }}
                variant="outlined"
            >
                {REWARDS_CONTENT[currentTab]}
            </Paper>
        </>
    )
}
